module.exports = __webpack_public_path__ + "static/media/home-bg-nz.38761ed4.jpg";